import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Snackbar,
  Alert
} from "@mui/material";

const API_BASE = "https://appapi.unpaidfinancial.com/api"; // adapte à ton backend

export default function ListeTemoignages() {
  const [temoignages, setTemoignages] = useState([]);
  const [open, setOpen] = useState(false);
  const [nom, setNom] = useState("");
  const [message, setMessage] = useState("");
  const [photo, setPhoto] = useState(null);
  const [snack, setSnack] = useState({ open: false, text: "", severity: "success" });

  // Charger tous les témoignages
  const fetchTemoignages = async () => {
    try {
      const res = await axios.get(`${API_BASE}/temoignages`);
      setTemoignages(res.data);
    } catch (err) {
      setSnack({ open: true, text: "Erreur de chargement.", severity: "error" });
    }
  };

  useEffect(() => {
    fetchTemoignages();
  }, []);

  // Ajouter un témoignage
  const handleAdd = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("nom", nom);
    formData.append("message", message);
    if (photo) formData.append("photo", photo);
    try {
      await axios.post(`${API_BASE}/temoignages`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      setSnack({ open: true, text: "Témoignage ajouté !", severity: "success" });
      setNom("");
      setMessage("");
      setPhoto(null);
      setOpen(false);
      fetchTemoignages();
    } catch {
      setSnack({ open: true, text: "Erreur lors de l'ajout.", severity: "error" });
    }
  };

  return (
    <Box sx={{ p: 3, maxWidth: 900, mx: "auto" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
        <Typography variant="h4" fontWeight={700}>
          Témoignages
        </Typography>
        <Button variant="contained" onClick={() => setOpen(true)}>
          Ajouter un témoignage
        </Button>
      </Box>
      <Grid container spacing={2}>
        {temoignages.length === 0 && (
          <Grid item xs={12}><Typography>Aucun témoignage pour le moment.</Typography></Grid>
        )}
        {temoignages.map((t) => (
          <Grid item xs={12} md={6} lg={4} key={t.id}>
            <Card>
              {t.photo && (
                <CardMedia
                  component="img"
                  height="120"
                  image={`${API_BASE.replace('/api', '')}/storage/${t.photo}`}
                  alt={t.nom}
                  sx={{ objectFit: "cover" }}
                />
              )}
              <CardContent>
                <Typography variant="h6">{t.nom}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {t.message}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Modal d'ajout */}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Ajouter un témoignage</DialogTitle>
        <DialogContent>
          <form id="form-temoignage" onSubmit={handleAdd} encType="multipart/form-data">
            <TextField
              label="Nom"
              fullWidth
              margin="normal"
              value={nom}
              onChange={e => setNom(e.target.value)}
              required
            />
            <TextField
              label="Témoignage"
              multiline
              rows={3}
              fullWidth
              margin="normal"
              value={message}
              onChange={e => setMessage(e.target.value)}
              required
            />
            <Button
              component="label"
              variant="outlined"
              fullWidth
              sx={{ my: 2 }}
            >
              {photo ? "Photo sélectionnée" : "Choisir une photo"}
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={e => setPhoto(e.target.files[0])}
              />
            </Button>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Annuler</Button>
          <Button type="submit" form="form-temoignage" variant="contained">Valider</Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snack.open}
        autoHideDuration={3500}
        onClose={() => setSnack({ ...snack, open: false })}
      >
        <Alert severity={snack.severity} sx={{ width: '100%' }}>
          {snack.text}
        </Alert>
      </Snackbar>
    </Box>
  );
}
